import { default as CE_TrackedUser } from "ce/utils/Analytics/trackedUser";

export default CE_TrackedUser;
